import { useState, useEffect } from 'react';

/**
 * Hook to fetch Instagram posts in real-time
 *
 * For now, this returns sample data. To connect to real Instagram:
 * 1. Get an Instagram Access Token from Meta Developer Console
 * 2. Replace the INSTAGRAM_TOKEN constant with your token
 * 3. Uncomment the real API fetch code below
 */

export const useInstagram = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        setLoading(true);

        // OPTION 1: Use Instagram Basic Display API (requires access token)
        // Uncomment and configure when you have your Instagram token
        /*
        const INSTAGRAM_TOKEN = 'YOUR_INSTAGRAM_ACCESS_TOKEN_HERE';
        const response = await fetch(
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${INSTAGRAM_TOKEN}`
        );
        const data = await response.json();
        
        if (data.data) {
          setPosts(data.data.slice(0, 6)); // Get first 6 posts
        }
        */

        // OPTION 2: For now, return sample data that matches your brand
        // Replace these with actual Instagram post URLs when integrating
        const samplePosts = [
          {
            id: '1',
            media_url:
              'https://images.pexels.com/photos/31928931/pexels-photo-31928931.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Wedding Photography',
          },
          {
            id: '2',
            media_url:
              'https://images.pexels.com/photos/35475949/pexels-photo-35475949.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Beautiful Moments',
          },
          {
            id: '3',
            media_url:
              'https://images.pexels.com/photos/35475957/pexels-photo-35475957.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Captured Memories',
          },
          {
            id: '4',
            media_url:
              'https://images.pexels.com/photos/35475961/pexels-photo-35475961.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Love Stories',
          },
          {
            id: '5',
            media_url:
              'https://images.pexels.com/photos/35475959/pexels-photo-35475959.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Special Occasions',
          },
          {
            id: '6',
            media_url:
              'https://images.pexels.com/photos/35475976/pexels-photo-35475976.jpeg',
            permalink: 'https://www.instagram.com/_btsandbeyond_',
            caption: 'Photography Excellence',
          },
        ];

        // Simulate API delay for realism
        await new Promise(resolve => setTimeout(resolve, 500));
        setPosts(samplePosts);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching Instagram posts:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchInstagramPosts();
  }, []);

  return { posts, loading, error };
};
